import { serverOrClient } from '@udemy/shared-utils';
export class CheckoutReferrerHelper {
  static saveCheckoutReferrer() {
    serverOrClient.global.sessionStorage.setItem(CheckoutReferrerHelper.checkoutReferrerUrlSessionKey, new URL(location.href).pathname);
  }
  static goToCheckoutReferrer() {
    const checkoutReferrer = serverOrClient.global.sessionStorage.getItem(CheckoutReferrerHelper.checkoutReferrerUrlSessionKey);
    serverOrClient.global.location.href = checkoutReferrer !== null && checkoutReferrer !== void 0 ? checkoutReferrer : '/cart';
  }
}
CheckoutReferrerHelper.checkoutReferrerUrlSessionKey = 'checkoutReferrerURL';
//# sourceMappingURL=checkout-referrer-helper.js.map